import React from 'react';
import "./not-found.css";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div>
      <section className="notfound">
        <h1 className="notfound-text">404</h1>
        <p className="notfound-desc">The page you are looking for doesn't exist.</p>
        <Link to="/" className="back-btn69">Go Back Home</Link>
      </section>
    </div>
  );
};

export default NotFound;
